function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M96 106.869C96 97 104.954 89 116 89s20 8 20 17.869V162.3s-4.1 5.7-19.783 5.7C100.535 168 96 162.3 96 162.3v-55.431z",
  fill: "#ECAD80"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M116 144c9.21 0 31.821-6.54 39.07-32.664 3.143.144 7.153-1.796 8.311-5.008l4.148-11.502c1.437-3.986-.523-8.423-4.379-9.909-1.714-.66-4.513-.627-6.11-.036C154.183 59.544 137.251 40 116 40c-21.457 0-38.366 19.925-40.801 45.62a7.221 7.221 0 00-6.349-.559c-3.855 1.486-5.816 5.923-4.379 9.91l4.097 11.362c1.382 3.831 5.399 5.853 9.132 4.685C85.688 138.637 106.675 144 116 144z",
  fill: "#FFD0AE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M112.47 94.213c.834-3.962 6.491-3.962 7.326 0l2.873 13.647a3.744 3.744 0 01-3.663 4.514h-5.746a3.744 3.744 0 01-3.663-4.514l2.873-13.647z",
  fill: "#ECAD80"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M70.058 90.546a3.173 3.173 0 013.559 0c1.6 1.066 2.155 3.224 2.312 5.266.16 2.078-.08 4.224-.236 5.474a.467.467 0 11-.928-.116c.155-1.245.383-3.31.231-5.287-.154-2.013-.691-3.754-1.898-4.559a2.238 2.238 0 00-2.521.001c-.776.517-1.43 1.599-1.43 3.353a.468.468 0 01-.936 0c0-1.989.751-3.402 1.847-4.132zm92.974 0a3.173 3.173 0 00-3.559 0c-1.601 1.066-2.156 3.224-2.313 5.266-.159 2.078.08 4.224.237 5.474a.467.467 0 10.928-.116c-.156-1.245-.384-3.31-.232-5.287.155-2.013.692-3.754 1.899-4.559a2.237 2.237 0 012.521.001c.776.517 1.43 1.599 1.43 3.353a.468.468 0 00.936 0c0-1.989-.751-3.402-1.847-4.132z",
  fill: "#212121"
});

function SvgHead1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 232,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default __webpack_public_path__ + "static/media/head-1.dc09bb10.svg";
export { SvgHead1 as ReactComponent };